export const LANGUAGES = { PL: 'pl' };

export const ENVIRONMENT_TYPE = {
	DEVELOP: 'DEVELOP',
	PRODUCTION: 'PRODUCTION'
};
